export default __webpack_public_path__ + "static/media/logo_ef.9c7da5fa.jpg";